import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { useUser } from "../hooks/useAuth";
import { modesRegistryQueryKey } from "../hooks/useModesRegistry";
import { apiClient } from "../utils/api";

/** Prefetch public modes registry once the user session is present (no legacy catalog/party APIs). */
export default function PostAuthCatalogHydration() {
  const { data: user } = useUser();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!user) return;
    void queryClient.prefetchQuery({
      queryKey: modesRegistryQueryKey,
      queryFn: () => apiClient.getModesRegistry(),
    });
  }, [user, queryClient]);

  return null;
}
